export default __webpack_public_path__ + "static/char-s-30-ja-9bd8a0c0176582578d123be5b5ca8f27.webp";